module.exports = __webpack_public_path__ + "static/screely-1579457606861-cef63b8bb52d67ee991646b2231ad0ef.png";